export default __webpack_public_path__ + "static/media/streak-shade-demo.8bfc09c3.gif";